class SymptomPicker extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('[data-faq-target]').forEach(link => {
      link.addEventListener('click', event => {
        const targetId = link.getAttribute('data-faq-target');
        const details = document.getElementById(targetId);

        if (!details) {
          return;
        }

        event.preventDefault();

        const summary = details.querySelector('summary');
        const body = details.querySelector('.accordion__body');

        details.classList.add('is-active');
        details.setAttribute('open', '');

        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }

        if (body) {
          body.style.height = 'auto';
          body.style.opacity = '1';
          body.style.transform = 'none';
        }

        details.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    });
  }
}

customElements.define('symptom-picker', SymptomPicker);
